import { Controller } from "@hotwired/stimulus"

// Polls the explanation backfill dashboard while backfill workers are running
export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.scheduleReload()
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  scheduleReload() {
    this.timeout = setTimeout(() => this.reloadDashboard(), this.intervalValue)
  }

  reloadDashboard() {
    const frame = document.getElementById("explanation_backfill_dashboard")
    if (frame) {
      frame.reload()
    }
    this.scheduleReload()
  }
}
